import { z } from "zod";
import { zAny, zArr, zBool, zNum, zObj, zOptional, zStr } from "./zodWrapper.js";
export const DeviceSensor = z.object({
    name: zOptional(zStr()),
    ias_registry_index: zOptional(zNum()),
    num_bytes: zOptional(zNum()),
    node_identifier: zOptional(zStr()),
    name_identifier: zOptional(zStr()),
    data_type: zOptional(zStr()),
    multiplier: zOptional(zNum()),
    accumulation_divider: zOptional(zNum()),
    high_freq_data: zOptional(zNum()),
    unit: zOptional(zStr()),
    aggregation_list: zOptional(zArr(zStr())),
    state_variable: zOptional(zBool()),
    dc: zOptional(zNum()),
    numbererval: zOptional(zNum()),
    avg_on_val: zOptional(zNum()),
    var_amp: zOptional(zNum()),
    var_numbererval: zOptional(zNum()),
    max_state_var_testdata: zOptional(zNum()),
    channel_number: zOptional(zNum()),
    channel_number_msg_index: zOptional(zNum()),
    bool_bit_address: zOptional(zNum()),
});
export const InOperation = z.object({
    threshold: zOptional(zNum()),
    sensor: zOptional(zStr()),
    greaterThan: zOptional(zBool()),
    always: zOptional(zBool()),
});
export const DeviceComponent = z.object({
    republish_interval: zOptional(zNum()),
    ping_interval: zOptional(zNum()),
    name: zOptional(zStr()),
    in_operation: zOptional(InOperation),
    sensors: zArr(DeviceSensor),
});
export const Node = z.object({
    slave_id: zOptional(zNum()),
    name: zOptional(zStr()),
    components: zArr(DeviceComponent),
});
export const Republisher = z.object({
    connectionstring: zStr(),
});
export const DataSource = z.object({
    ip: zOptional(zStr()),
    port: zOptional(zNum()),
    url: zOptional(zStr()),
    name: zOptional(zStr()),
    communication_type: zOptional(zStr()),
    read_command: zOptional(zStr()),
    unit_id: zOptional(zNum()),
    com_port: zOptional(zStr()),
    baud_rate: zOptional(zNum()),
    stop_bits: zOptional(zNum()),
    byte_size: zOptional(zNum()),
    timeout: zOptional(zNum()),
    debug_print: zOptional(zBool()),
    fetch_interval: zOptional(zNum()),
    node_req_delay: zOptional(zNum()),
    nodes: zArr(Node),
});
export const VNCsource = z.object({
    ip: zStr(),
    port: zNum(),
    name: zStr(),
});
export const CAMsource = z.object({
    name: zStr(),
    url: zStr(),
});
export const Stream = z.object({
    vnc_sources: zOptional(zArr(VNCsource)),
    cam_sources: zOptional(zArr(CAMsource)),
});
export const Calculator = z.object({
    expression: zOptional(zStr()),
    republish_interval: zOptional(zNum()),
    name: zOptional(zStr()),
    aggregation_list: zOptional(zArr(zStr())),
});
export const ConfigData = z.object({
    version: zStr(),
    republishing: zArr(Republisher),
    data_sources: zArr(DataSource),
    data_calculators: zOptional(zArr(Calculator)),
    stream: zOptional(Stream),
});
export const DeviceConfigAddArgs = zObj({ deviceId: zNum(), config: zAny() });
export const DeviceConfigGetArgs = zObj({
    id: zNum(),
});
export const DeviceConfigPushHistoryArgs = zObj({
    id: zNum(),
});
export const DeviceConfigPushArgs = zObj({
    deviceId: zNum(),
    configId: zNum(),
    timestamp: zStr(),
});
export const DbDeviceConfig = zObj({
    id: zNum(),
    deviceId: zNum(),
    config: zAny(),
    timestamp: zStr(),
});
export const DbDeviceConfigs = zArr(DbDeviceConfig);
export const DeviceConfigPushItem = zObj({
    id: zNum(),
    deviceId: zNum(),
    config: zAny(),
    timestamp: zStr(),
    pushed: zBool(),
});
export const DeviceConfigPushHistory = zArr(DeviceConfigPushItem);
export const DeviceSignalUpdateArgs = zObj({
    deviceId: zNum(),
    token: zStr(),
});
export const DeviceSignalRebootArgs = zObj({
    deviceId: zNum(),
});
export const DeviceUpdateHistoryArgs = zObj({
    deviceId: zNum(),
});
export const DeviceUpdateItem = zObj({
    id: zNum(),
    deviceId: zNum(),
    timestamp: zStr(),
    pushed: zBool(),
});
export const DeviceUpdateHistory = zArr(DeviceUpdateItem);
//# sourceMappingURL=deviceConfig.js.map